'use strict';

/**
 * @name network
 */

exports.request = require('./request.js');
exports.sendSms = require('./send-sms.js');

//exports.httpRequest = require('./http-request.js'); // not support POST, disabled
